const FOOTER_CLASSES_PREFIX = "Footer";

export const FOOTER_CLASSES = {
  container: `${FOOTER_CLASSES_PREFIX}-container`,
  contentWrapper: `${FOOTER_CLASSES_PREFIX}-contentWrapper`,
  countrySelectorWrapper: `${FOOTER_CLASSES_PREFIX}-countrySelectorWrapper`,
  evergageData: `${FOOTER_CLASSES_PREFIX}-evergageData`,
};
